import client from './client';

export default (function PnmService() {
  let service;

  if (!service) {
    service = client.service('pnms');
  }

  return service;
}());
